import {takeEvery} from 'redux-saga/effects'
import {
  GET_COLLEGE_COUNSELLING_SETTINGS,
  UPDATE_COLLEGE_COUNSELLING_SETTINGS,
} from 'setup/redux/Actions/CollegeCounsellingSettings/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* collegeCounsellingSettingsSaga() {
  yield takeEvery(GET_COLLEGE_COUNSELLING_SETTINGS, fetchData)
  yield takeEvery(UPDATE_COLLEGE_COUNSELLING_SETTINGS, fetchData)
}

export default collegeCounsellingSettingsSaga
